import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Layout from "../../../components/dashboard/Layout";
import AddAnnouncement from "../../../containers/admin/announcements/models/add-announcement";
import SearchBar from "../../../containers/admin/announcements/searchbar";
import AnnouncementsTable from "../../../containers/admin/announcements/table";
import { getAllAnnouncementsRequest } from "../../../modules/admin-modules/announcements/Actions";

const Announcements = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const isLoading = useSelector((state) => state.user.isLoading);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const isSuperAdmin =
    user?.role &&
    Array.isArray(user.role) &&
    user.role.some((role) => role?.name === "Super Admin");

  useEffect(() => {
    if (isLoading) return;

    if (user?.role && Array.isArray(user.role)) {
      if (!isSuperAdmin) {
        navigate("/dashboard/students");
        return;
      }
      dispatch(getAllAnnouncementsRequest());
    }
  }, [user, isLoading, isSuperAdmin, navigate, dispatch]);

  if (isLoading || !user?.role || !isSuperAdmin) {
    return null;
  }

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <AnnouncementsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />
      <AddAnnouncement
        key={`announcement-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Announcements;
